import React from 'react';
import { Avatar as Avtr } from 'antd';
import AvatarInfo from './avatar-info';
import AvatarGroup from './avatar-group';

/**
 * Avatar component that wraps antd Avatar with predefined sizes
 *
 * {@link https://ant.design/components/avatar#avatar}
 *
 * @module Avatar
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to render inside avatar
 * @param {string} [props.className] - Additional CSS class name
 * @param {string} [props.size={48}] - Size variant ('mini'|'small'|'medium'|'large'|'jumbo') or int in px
 * @returns {React.ReactElement} Rendered Avatar component
 */
const Avatar = ( { children, ...props } ) => {
    const { className, size } = props;
    switch ( size ) {
        case 'mini':
            return <Avtr { ...props } size={ 24 } className={ className ? `mini-avatar ${ className }` : 'mini-avatar' }>
                { children }
            </Avtr>;
        case 'small':
            return <Avtr { ...props }   size={ 36 } className={ className ? `small-avatar ${ className }` : 'small-avatar' }>
                { children }
            </Avtr>;
        case 'medium':
            return <Avtr { ...props }   size={ 48 } className={ className ? `medium-avatar ${ className }` : 'medium-avatar' }>
                { children }
            </Avtr>;
        case 'large':
            return <Avtr { ...props }  size={ 64 } className={ className ? `large-avatar ${ className }` : 'large-avatar' }>
                { children }
            </Avtr>;
        case 'jumbo':
            return <Avtr { ...props }  size={ 128 } className={ className ? `jumbo-avatar ${ className }` : 'jumbo-avatar' }>
                { children }
            </Avtr>;
        default:
            return <Avtr size={ 48 } { ...props } className={ className ? `avatar ${ className }` : 'avatar' }>
                { children }
            </Avtr>;
    }
};

/**
 * Group property for Avatar component
 * @type {typeof AvatarGroup}
 */
Avatar.Group = AvatarGroup;

/**
 * Info property for Avatar component
 * @type {typeof AvatarInfo}
 */
Avatar.Info = AvatarInfo;

export { Avatar };


